<template>
    <section>
        <!--<div class="row">
            <div class="col-12 section headline" style="background-image: url(http://via.placeholder.com/800x600);"></div>
        </div>-->
        <div class="row">
            <div class="col-12 px-5">
                <h1 class="text-danger text-uppercase font-weight-bold my-5">Berita</h1>
            </div>
        </div>
        <div class="row" v-if="recentArticle">
            <div class="col-12 section new">
                <div class="row background-primary">
                    <div class="col-6 p-0">
                        <div class="thumbnail" v-bind:style="{'background-image': 'url(' + recentArticle.imageUrl + ')'}"></div>
                    </div>
                    <div class="col-6 p-5 text-white">
                        <div class="content">
                            <h1 class="text-uppercase font-weight-bold mb-4">Berita Terbaru</h1>
                            <h1 class="font-weight-bold mb-1 title">{{ recentArticle.title }}</h1>
                            <div class="mb-3 date">{{ [recentArticle.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY") }}</div>
                            <div class="summary mb-2" v-html="recentArticle.content"></div>
                            <div class="footer">
                                <router-link v-bind:to=" {name: 'article/view', params: { id: recentArticle.id } } " class="font-weight-medium">
                                    Selengkapnya
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 section list px-5">
                <h2 class="text-danger font-weight-bold my-5">Berita Sebelumnya</h2>
                <div class="row">
                    <div class="col-12 col-lg-6 mb-5" v-for="article in articles">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="rounded thumbnail mb-4 mb-sm-0" v-bind:style="{'background-image': 'url(' + article.imageUrl + ')'}"></div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <router-link v-bind:to="{ name: 'article/view', params: { id: article.id } }" class="h3 font-weight-bold text-dark mb-2 d-block">{{ article.title }}</router-link>
                                <h4 class="text-danger font-weight-medium mb-4">{{ [article.createdAt, "YYYY-MM-DD HH:mm:ss"] | moment("D MMMM YYYY") }}</h4>
                                <div class="summary mb-2" v-html="article.content"></div>
                                <router-link v-bind:to="{ name: 'article/view', params: { id: article.id } }" class="position-absolute" style="bottom: 0;">
                                    Selengkapnya
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="!endOfPage">
                    <div class="row justify-content-center">
                        <div class="col-md-4 text-center">
                            <button type="button" class="btn btn-danger btn-block" v-on:click="paginate(page + 1)">
                                Selanjutnya
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ArticleIndex",
        data: function () {
            return {
                recentArticle: null,
                articles: [],
                pageCount: 0,
                page: 1,
                endOfPage: false
            };
        },
        methods: {
            paginate(page) {
                if (!this.endOfPage) {
                    this.axios.get(process.env.API_URL + '/article', {params: Object.assign({}, this.form, {page: page, limit: 8, skip: 1})}).then(response => {
                        this.articles = this.articles.concat(response.data.data.data);
                        this.pageCount = response.data.data.total ? response.data.data.last_page : 0;
                        this.page = page;

                        if (this.page >= this.pageCount) {
                            this.endOfPage = true;
                        }
                    });
                }
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/article/most-recent').then(response => {
                this.recentArticle = response.data.data;
            });
            this.paginate(1);
        },
        mounted() {
            document.title = 'Berita - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .section.headline { height: 30vh; background-position: center; background-repeat: no-repeat; background-size: cover; background-color: #c3c3c3; }
    .section.new .thumbnail{ background-repeat: no-repeat; background-size: cover; background-position: center; background-color: #c3c3c3; height: 100%; }
    .section.list .thumbnail{ background-repeat: no-repeat; background-size: cover; background-position: center; background-color: #c3c3c3; height: 20rem; }
    .section .summary { display: block; overflow: hidden; max-height: 7rem; }
</style>


// WEBPACK FOOTER //
// src/components/article/Index.vue